<template>
	<div class="billing">
		<v-layout row wrap>
			<v-flex md10>
				<filter-list class="mb-3" v-bind:value="filterValue" v-bind:loading="loading" v-on:selected-filter="selectedFilter" />
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create text="Billing"></button-create>
			</v-flex>
		</v-layout>
		<table-run v-bind:columns="columns"
				   v-bind:rows="rows"
				   v-bind:include-delete="false"
				   v-bind:include-export-to-excel="false"
				   v-bind:include-options="true"
				   v-bind:include-switch="false"
				   v-bind:include-settings="true"
				   v-bind:include-delete-single="true"
				   v-bind:selectable="false"
				   v-bind:switch-value="'flagActive'"
				   v-on:on-sortable-event="columnSortableEvent"
				   v-on:on-search-event="searchByColumn"
				   class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{ props.row.number }}</td>
				<td>{{ props.row.name }}</td>
				<td>{{ props.row.ruc }}</td>
				<td>{{ props.row.direction }}</td>
				<td>{{ props.row.amount }}</td>
				<td>{{ props.row.code_roomtype }}<span v-if="props.row.code_roomtype && props.row.room_number">-</span>{{ props.row.room_number }}</td>
			</template>    
		</table-run>
		<v-layout row wrap justify-end mt-3 v-show="totalPages">
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page">
			</v-pagination>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import mixin from '@/shared/mixins';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';


async function changeState({ id }) {
	const modelRow = this.rows.filter(row => row.id === id)[0];
	await this.$http.patch(`${process.env.PRODUCTS_URL}/warehouses/${id}/flag-active`, { flagActive: modelRow.flagActive });
	this.loadData();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		this.flagActive = 1;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else if (filter.id === 3) {
		this.flagActive = 0;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else {
		this.flagActive = null;
		this.loading = true;
		this.page = 1;
		this.loadData();
	}
}

export default {
	components: {
		ButtonCreate,
		FilterList,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	data() {
		return {
			columns: [
				{ id: 1, name: 'N', code: 'number', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Name', code: 'name', isSortable: { down: true, up: false } },
				{ id: 3, name: 'R.U.C.', code: 'ruc', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Direction', code: 'direction', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Total Amount', code: 'amount', isSortable: { down: true, up: false } },
				{ id: 6, name: '', code: '' },
			],
			filterValue: 1,
			flagActive: null,
			limit: 10,
			loading: false,
			page: 1,
			resource: null,
			rows: [
				{
					number: 1,
					name: 'Ariel Esteban Puga Ogalde',
					ruc: 20214392548,
					direction: 'av.Arequipa 3492 Lima-Perú',
					amount: 530.39,
				},
				{
					number: 1,
					name: 'Ariel Esteban Puga Ogalde',
					ruc: 20214392548,
					direction: 'av.Arequipa 3492 Lima-Perú',
					amount: 530.39,
				},
				{
					number: 1,
					name: 'Ariel Esteban Puga Ogalde',
					ruc: 20214392548,
					direction: 'av.Arequipa 3492 Lima-Perú',
					amount: 530.39,
				},
				{
					number: 1,
					name: 'Ariel Esteban Puga Ogalde',
					ruc: 20214392548,
					direction: 'av.Arequipa 3492 Lima-Perú',
					amount: 530.39,
				},
				{
					number: 1,
					name: 'Ariel Esteban Puga Ogalde',
					ruc: 20214392548,
					direction: 'av.Arequipa 3492 Lima-Perú',
					amount: 530.39,
				},
			],
			totalPages: 5,
			search: null,
			sortDirection: null,
			sortField: null,
		};
	},
	name: 'minibar',
	methods: {
		changeState,
		columnSortableEvent,
		searchByColumn,
		selectedFilter,
	},
	mixins: mixin,
};
</script>

<style lang="scss" scoped>
	.column-transfer {
		position: absolute;
		right: 158px;

		a {
			i {
				color: map-get($colors, blue-title);
				height: 16px !important;
				margin-top: 13px;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// List.vue?4b244d69